import { useAppearanceStore } from '@/store/appearance';
import { useSiteStore } from '@/store/site';
import { useBetslipStore } from '@/store/betslip';
import { ViewEnum } from '@/types';

export const useOddsPageSwitcher = () => {
	const view = useAppearanceStore(state => state.view);
	const [
		isParlayMode, 
		isFilterBetBuilderPlus,
		activeMatches,
		activeFilterParlay,
		activeFilterParlayWithFullMenu,
		activeFilterBetBuilderPlus,
		activeFilterCorrectScore,
		disableBetBuilderPlusOnly,
		setIsFilterCorrectScore
	] = useSiteStore(state => [
		state.isParlayMode, 
		state.isFilterBetBuilderPlus,
		state.activeMatches,
		state.activeFilterParlay,
		state.activeFilterParlayWithFullMenu,
		state.activeFilterBetBuilderPlus,
		state.activeFilterCorrectScore,
		state.disableBetBuilderPlusOnly,
		state.setIsFilterCorrectScore
	]);
	const switchToUserBetSlipTab = useBetslipStore(state => state.switchToUserBetSlipTab);

	const switchToParlay = (options?: { useFullSportMenu?: boolean }) => {
		if (options?.useFullSportMenu) {
			activeFilterParlayWithFullMenu();
			return;
		}
		activeFilterParlay();
	}
	const disableParlay = () => {
		activeMatches();
		switchToUserBetSlipTab('single');
	}
	const switchToBetBuilderPlus = () => {
		activeFilterBetBuilderPlus();
	}
	const disableBetBuilderPlus = () => {
		disableBetBuilderPlusOnly();
	}
	const switchToCorrectScore = () => {
		activeFilterCorrectScore();
	}
	const switchToMatches = () => {
		activeMatches();
		switchToUserBetSlipTab('single');
	}
	const resetSwitcher = () => {
		setIsFilterCorrectScore(false);
		if (view === ViewEnum.galaxy) {
			activeMatches();
			switchToUserBetSlipTab('single');
		}

		if (view === ViewEnum.mars) {
			if (isParlayMode) {
				// 因為mars sport 頁面若在parlay mode 下 可以切換sport 不關閉parlay 模式
				return;
			}

			if (isFilterBetBuilderPlus) {
				disableBetBuilderPlusOnly();
			}
			return;
		}
	}
	return {
		resetSwitcher,
		switchToParlay,
		disableParlay,
		switchToBetBuilderPlus,
		disableBetBuilderPlus,
		switchToCorrectScore,
		switchToMatches
	};
};